/* eslint-disable react-hooks/exhaustive-deps */
import {
faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown } from 'react-bootstrap';
import { getBadges } from '../../features/dashboard/components/helpers';
import { toast } from 'react-toastify';
import {
    matchPath,
    useLocation,
    useNavigate,
    useParams,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../template/store';
import { faArrowAltCircleLeft, faCopy } from '@fortawesome/free-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
    toggleEBLDocumentHistoryColumnShort,
    updateEBLInstructionID,
} from '../../features/ebl/slices/eBLDocumentHistorySlice';
import {
    getEBLInstructionTypes
} from './actions/eBLActions';
import { useEffect, useMemo, useState } from 'react';
import { AESDecrypt, AESEncrypt } from '../../../encrypt-util';
import {
    // updateSelectedDocIdDH,
    updateSelectedEventIdDH,
} from '../../features/ebl/slices/eBLDocumentHistorySlice';
import { useBackNavigation } from '../../../hooks/BackNavigation';
import useDataCountry from '../../../hooks/useDataCountry';
import { useLoading } from '../../../middleware/loadingMiddleware';
import {
    faFilePdf

} from '@fortawesome/free-regular-svg-icons';

const EBLHeader = () => {

    const location = useLocation();
    const goBack = useBackNavigation(false);
    const { blId, encrypt } = useParams();

    const blNumber = useSelector((state: RootState) => state.oblDetails.oblForm.number);

    const profileDetails = useSelector(
        (state: RootState) => state.userProfile.profile
    );

    const oblLoading = useSelector(
        (state: RootState) => state.oblDetails.isOblDetailsLoading
    );
    const historyLoading = useLoading(['instruction/getInstruction'])
    const listLoading = useSelector(
        (state: RootState) => state.documentHistory.loadInstructList
    );
    const blNumDisplay = useSelector(
        (state: RootState) => state.eblDetails.eblData?.blNo
      );
    
    const displayNumber = blNumDisplay? blNumDisplay :'';

    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const { t } = useTranslation();


    const _onBackNav = () => {
        dispatch(updateSelectedEventIdDH(null));
        goBack();
    };

    const instructionTypes = useSelector(
        (state: RootState) => state.eBLDocumentHistory.eBLInstructionTypes
    );


    //////


    // const tableData: any = useSelector(
    //     (state: RootState) => state.eBLDocumentHistory.eBLDocumentHistory
    // );
    // const blid = useMemo(() => tableData?.[0]?.blId, [tableData])
    // const oblForm = useSelector((state: RootState) => state.oblDetails.oblForm);
    // const datacountry = useDataCountry()
    // const isImport: boolean =
    //     // tableData.filter((v: any) => v?.invAccess !== null && v?.invAccess === 'Y')
    //     //   .length > 0 &&
    //     tableData.filter(
    //         (v: any) =>
    //             (v?.instructionId == 805 ||
    //                 v?.instructionId == 812 ||
    //                 v?.instructionId == 811) &&
    //             v?.docStatus == 'Y'
    //     ).length > 0;
    // const isExport: boolean =
    //     tableData.filter((v: any) => v?.invAccess !== null && v?.invAccess === 'Y')
    //         .length > 0 &&
    //     tableData.filter(
    //         (v: any) =>
    //             (v?.instructionId == 814 ||
    //                 v?.instructionId == 813 ||
    //                 v?.instructionId == 815) &&
    //             v?.docStatus == 'Y'
    //     ).length > 0;


    /////////////

    // const [instructionAllowed, setInstructionAllowed] = useState(false);
    // const [isShipper, setIsShipper] = useState(false);
    // const [isConsignee, setIsConsignee] = useState(false);
    // const selectedLinerId = useSelector(
    //   (state: RootState) => state.navbarTop.linerId
    // );

     const blPartyList = useSelector(
        (state: RootState) => state.documentHistory.blPartyList
    );

    const rbac = useSelector((state: RootState) => state.userProfile);
   
    useEffect(() => {
        if(blNumber){

            dispatch(getEBLInstructionTypes({eblNo:blNumber}));
        }

    }, [blNumber]);



    
    

    // const instructionItems = instructionTypes.map((option: any) => {

    //     return (
    //         <div>
    //             {option.index !== 0 ? <Dropdown.Divider /> : <></>}
    //             <Dropdown.Item
    //                 onClick={async () => {
    //                     //   dispatch(updateSelectedDocIdDH(''));
    //                     dispatch(updateSelectedEventIdDH(''));
    //                     // dispatch(updateEBLInstructionID(option.id));
    //                     dispatch(updateEBLInstructionID(option.shortCode));
                    
    //                     navigate(
    //                         `/ebl/${encodeURIComponent(
    //                             blNum || ''
    //                         )}/instruction/${AESEncrypt(option.shortCode)}${location?.search || ''
    //                         }`
    //                     );
    //                 }}
    //             >
    //                 {option.displayName}
    //             </Dropdown.Item>
    //         </div>
    //     );
    // });

const handleCopyBL = async (e: React.MouseEvent) => {
  e.stopPropagation();
  try {
   
    if (displayNumber) {
      await navigator.clipboard.writeText( displayNumber || '');
     
    } else {
      toast.error(t('resource_2:copyFailed') as string);
    }
  } catch (error) {
    console.error('Copy failed:', error);
    toast.error(t('resource_2:copyFailed') as string);
  }
};

    const instructionItems = instructionTypes.length > 0 ? (
    instructionTypes.map((option: any, index: number) => (
        <div key={option.id || index}>
            {index !== 0 && <Dropdown.Divider />}
            <Dropdown.Item
                onClick={async () => {
                    dispatch(updateSelectedEventIdDH(''));
                    dispatch(updateEBLInstructionID(option.shortCode));
                    navigate(
                        `/ebl/${encodeURIComponent(blId || '')}/instruction/${AESEncrypt(option.shortCode)}${location?.search || ''}`
                    );
                }}
            >
                {option.displayName}
            </Dropdown.Item>
        </div>
    ))
) : (
    // <Dropdown.Item disabled className="text-muted">

     <Dropdown.Item
            disabled
            className="text-muted"
            style={{ 
                fontSize: '1rem',        
                minWidth: '165px',      
                 paddingTop: '0px',   
        paddingBottom: '4px', 
        lineHeight: '1.2',   
                   
            }}
        >
        No available actions for the eBL
    </Dropdown.Item>
);



    return (
        <div className='p-0 ps-3 pe-3 d-flex align-items-center odex-mh-60px w-100 border-bottom'>
            <div className='d-flex justify-content-start align-items-center'>
                {/*   {  (location.pathname === "/standing-instruction/") ?
         "": */}{' '}
                <FontAwesomeIcon
                    icon={faArrowAltCircleLeft}
                    className='text-warning me-3 cursor-pointer'
                    size='lg'
                    onClick={_onBackNav}
                />
                {profileDetails?.partnerType !== 'liner' ? (
                    <>
                        <div
                            className='d-flex justify-content-start align-items-between '
                            style={oblLoading || historyLoading ? { pointerEvents: 'none' } : {}}>
                            <Dropdown drop='down'>
                                <Dropdown.Toggle
                                    className='no-caret-dropdown-toggle cursor-pointer'
                                    as='div'>
                                    <Button
                                        variant='falcon-primary'
                                        size='sm'
                                        style={{ marginRight: '0.5rem', position: 'relative' }}
                                        disabled={oblLoading || listLoading || historyLoading}>
                                        <div className='d-flex'>
                                            <FontAwesomeIcon icon={faPlus} className='me-2 mt-1 ' />
                                            {location.pathname.includes('ebl/') ? <span>eBL Actions</span> : <span>Instruct</span>}
                                            {/* <span>Instruct</span> */}
                                        </div>
                                    </Button>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>{instructionItems}</Dropdown.Menu>
                            </Dropdown>


                            <div className='d-flex justify-content-center align-items-center'>
                                          <Button
                                            className='me-2'
                                            variant='falcon-primary'
                                            size='sm'
                                            onClick={()=>{
                                                // alert("12")
                                                // dispatch(downloadEblPdf({eBLNo:AESDecrypt(blNum)}))
                                                window.open(
                                                    `${process.env.REACT_APP_CLIENT_APP_HOST}/api/gsbn/v1/eBl/${blNumber}/pdf`,
                                                    '_blank'
                                                );
                                            }
                                            }
                                            >
                                            <FontAwesomeIcon icon={faFilePdf}style={{ fontSize: '14px', color: '#f5822a' }} className='me-2' />
                                            <span>eBL PDF</span>
                                          </Button>
                                        </div>
                         
                        </div>

                    </>
                ) : (
                    ''
                )}
            </div>

            {displayNumber && (
                <div className="d-flex align-items-center ms-3">
                    <span className="text-muted me-1"> BL No.</span>
                    <span className="fw-bold me-1">{displayNumber || ''}</span>
                    <button
                        className="btn btn-link p-0"
                        onClick={handleCopyBL}
                        title="Copy BL number"
                    >
                        <FontAwesomeIcon icon={faCopy} className="text-primary" />
                    </button>
                </div>
            )}

        </div>
    );
};

export default EBLHeader;
